export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/sx.96ff0bc2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};